import { useTranslation } from 'react-i18next';
import { gql } from '@apollo/client';
import {
  MetricSumNewContactsAcquisitionWhereInput,
  Query,
} from '@lgg/isomorphic/types/__generated__/graphql';
import {
  CardMainNumericValue,
  GenericSmallCard,
} from 'src/components/pages/dashboard/components/shared';

export const GET_METRIC_NEW_CONTACT_ACQUISITION_QUERY = gql`
  query GetMetricSumNewContactsAcquisition(
    $institutionId: Int!
    $period: MetricPeriodWhereInput!
    $comparePeriod: MetricComparePeriodInput
    $where: MetricSumNewContactsAcquisitionWhereInput
  ) {
    metricSumNewContactsAcquisition(
      institutionId: $institutionId
      period: $period
      comparePeriod: $comparePeriod
      where: $where
    ) {
      total
      previousPeriod {
        total
        trendChangePercentage
        trendChangeIndicator
      }
      lastUpdatedAt
    }
  }
`;

export const NewContactAcquisitionCard = () => {
  const { t } = useTranslation(['dashboard']);

  return (
    <GenericSmallCard<
      Pick<Query, 'metricSumNewContactsAcquisition'>,
      MetricSumNewContactsAcquisitionWhereInput
    >
      title={t('dashboard:cards.newContactAcquisition.title')}
      query={GET_METRIC_NEW_CONTACT_ACQUISITION_QUERY}
      dataResolver={(result) => {
        const metricData = result.data?.metricSumNewContactsAcquisition;

        if (!metricData) {
          return undefined;
        }

        const { lastUpdatedAt, total = null, previousPeriod } = metricData;

        return {
          lastUpdatedAt,
          total,
          previousPeriod: previousPeriod
            ? {
                trendChangePercentage: previousPeriod?.trendChangePercentage ?? 0,
                trendChangeIndicator: previousPeriod?.trendChangeIndicator,
                total: previousPeriod?.total ?? 0,
              }
            : null,
        };
      }}
      whereResolver={({ targetUserId }) => ({
        dimensionContactAssignee: { id: { _eq: targetUserId } },
      })}
      valueTransformer={(value = null) => <CardMainNumericValue value={value} />}
      cardInfoI18nKey="dashboard:cards.newContactAcquisition.tooltipDescription"
      testId="dashboard-new-contact-acquisition-card"
    />
  );
};
